import type { ReadableAtom, WritableAtom } from "nanostores";
import type { AgentClientDefinition } from "@/agent/client/types";
import type { AgentClient } from "@/exports/client";
import type { Any } from "@/shared/types";
import type { TelemetryClient } from "@/telemetry/clients/base";

export type AgentClientAtom = {
  store: WritableAtom | ReadableAtom;
  refresh: () => Promise<void>;
};

export type AgentAtomDefinition<Name extends string = string> = (params: {
  agent: AgentClient<AgentClientDefinition>;
  telemetry: TelemetryClient;
}) => {
  name: Name;
  create: (...params: Any[]) => AgentClientAtom;
};

export function defineAgentAtom<
  const Name extends string,
  const AtomDef extends AgentAtomDefinition<Name>,
>(atomDef: AtomDef) {
  return atomDef;
}
